import radians from './radians'

export default function rotatePoint(p, angle) {
  const rad = radians(angle)

  return Array.isArray(p)
    ? [p[0] * Math.cos(rad) - p[1] * Math.sin(rad), p[0] * Math.sin(rad) + p[1] * Math.cos(rad)]
    : {
        x: p.x * Math.cos(rad) - p.y * Math.sin(rad),
        y: p.x * Math.sin(rad) + p.y * Math.cos(rad),
      }
}
